import { DialogContent, Stack, Typography } from "@mui/material";
import { Control } from "react-hook-form";
import { InternationalPhone } from "../../../../components/common/InternationalPhone";
import { FormButtonGroup } from "../../../../components/form";

interface IFormInput {
  phone: string;
  confirmationCode: string;
}

interface IProps {
  control: Control<IFormInput | any>;
  loading: boolean;
  disabledConfirmButton: boolean;
  onCancelButtonClick: Function;
  onConfirmButtonClick: Function;
}

export default function PhoneFormContent({
  control,
  loading,
  disabledConfirmButton,
  onCancelButtonClick,
  onConfirmButtonClick,
}: IProps) {
  return (
    <DialogContent>
      <Stack spacing={2}>
        <Typography
          textAlign="center"
          color="neutral600.main"
          variant="body1"
          sx={{ px: 4 }}
        >
          Enviaremos um SMS com um código para validarmos o seu número de
          telefone
        </Typography>
        <InternationalPhone name="phone" label="Telefone" control={control} />
      </Stack>
      <Stack
        minWidth="100%"
        mt={3}
        direction="row"
        justifyContent="space-between"
        spacing={2}
      >
        <FormButtonGroup
          onGoBackButtonClick={() => onCancelButtonClick()}
          onNextButtonClick={() => onConfirmButtonClick()}
          goBackButtonText="Cancelar"
          nextButtonText="Confirmar"
          loading={loading}
          disabled={disabledConfirmButton}
        />
      </Stack>
    </DialogContent>
  );
}
